import PropTypes from 'prop-types';
import { Typography, makeStyles } from '@material-ui/core';
import { ReactComponent as LogoIcon } from '../../../../../../assets/icons/kadar_logo_mark_app.svg';

const useStyles = makeStyles(() => ({
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  logo: {
    flexShrink: 0,
    width: 24,
    height: 24,
    marginRight: 6,
  },
}));

const AssistantAvatar = ({ translations, className = '' }) => {
  const classes = useStyles();

  return (
    <div className={className}>
      <div className={classes.row}>
        <LogoIcon className={classes.logo} aria-hidden />
        <Typography variant="subtitle1" component="span">
          {`Kadar ${translations.assistant}`}
        </Typography>
      </div>
    </div>
  );
};

AssistantAvatar.propTypes = {
  translations: PropTypes.object.isRequired,
  className: PropTypes.string,
};

export default AssistantAvatar;
